
<p-toast></p-toast>
<div class="card " reflow="true">
    <div class="flex flex-wrap align-items-center justify-content-center">
        <div class="field">
            <label for="date" class="mr-6" style="font-weight: 600;">{{'SELECT_DATE'| translate}}</label>
            <p-calendar
            [(ngModel)]="selectedDate"
            [showIcon]="true"
            inputId="date"
          ></p-calendar>
        </div>
    </div>    
    <div class="flex flex-wrap align-items-center justify-content-center mt-5">
        <button pButton pRipple label="{{'SUBMIT'| translate}}" class="p-button-success" (click)="submitHandler()"></button>
    </div>
</div>
<div  >
    <p-tabMenu *ngIf="showTabs" [model]="items" [activeItem]="items[0]" class="mb-2">
    </p-tabMenu>
    <router-outlet *ngIf="showTabs" ></router-outlet>
</div>

